import { render, staticRenderFns } from "./BISummarySection.vue?vue&type=template&id=4c4c00f2"
import script from "./BISummarySection.vue?vue&type=script&lang=js"
export * from "./BISummarySection.vue?vue&type=script&lang=js"
import style0 from "./BISummarySection.vue?vue&type=style&index=0&id=4c4c00f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports